import { useSuspenseQuery } from '@tanstack/react-query';
import * as React from 'react';

import type { NavigationScreenSitePreviewAuthState } from '@gitbook/app-navigation';
import { Icon } from '@gitbook/spine-icons';
import { EmptyState, EmptyStateIcon, Heading } from '@gitbook/spine-react';

import { apiQuery } from '../../state';

/** Redirect users to site preview with auth token, while safely handling optional redirect targets. */
export function RedirectWithSitePreview(props: { screen: NavigationScreenSitePreviewAuthState }) {
    return (
        <React.Suspense fallback={<RedirectWithSitePreviewFallback />}>
            <AuthSitePreview {...props} />
        </React.Suspense>
    );
}

function AuthSitePreview(props: { screen: NavigationScreenSitePreviewAuthState }) {
    const {
        screen: { organization, site, redirect },
    } = props;

    const {
        data: { url },
    } = useSuspenseQuery(
        apiQuery('getSitePublishingPreviewById', {
            organizationId: organization,
            siteId: site,
            target: redirect,
        })
    );

    React.useEffect(() => {
        window.location.href = url;
    }, [url]);

    return <RedirectWithSitePreviewFallback />;
}

function RedirectWithSitePreviewFallback() {
    return (
        <EmptyState>
            <EmptyStateIcon>
                <Icon.DocsSite size={24} className="text-neutral-low" />
            </EmptyStateIcon>
            <Heading>Opening preview…</Heading>
        </EmptyState>
    );
}
